var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWarningEditProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "20px",
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icWarningEditProfile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.5565514,16.9591909 L12.7730907,0.663668252 C12.5167384,0.251828245 12.0564602,2.30926389e-14 11.5599666,2.30926389e-14 C11.063473,2.30926389e-14 10.6031948,0.251784502 10.3468425,0.663668252 L0.203472062,16.9591909 C-0.0603310697,17.3830165 -0.0681431104,17.9116502 0.183106569,18.3425622 C0.434356248,18.7735179 0.9056526,19.04 1.41655103,19.04 L20.3434273,19.04 C20.8543257,19.04 21.3256221,18.7734741 21.5768718,18.3425622 C21.8281215,17.9116065 21.8203546,17.3830165 21.5565514,16.9591909 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit-Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icWarningEditProfile"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FF0000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2269966,5.44 C11.7757121,5.44 12.24,5.7601868 12.24,6.32770668 C12.24,8.0594342 12.0430307,10.5479869 12.0430307,12.2797144 C12.0430307,12.7308707 11.5646644,12.92 11.2269966,12.92 C10.7768296,12.92 10.3969268,12.7308267 10.3969268,12.2797144 C10.3969268,10.5479869 10.2,8.0594342 10.2,6.32770668 C10.2,5.7601868 10.650167,5.44 11.2269966,5.44 Z M11.2266709,15.64 C10.6400364,15.64 10.2,15.163119 10.2,14.62 C10.2,14.0636254 10.639996,13.6 11.2266709,13.6 C11.7733204,13.6 12.24,14.0636254 12.24,14.62 C12.24,15.163119 11.7733204,15.64 11.2266709,15.64 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarningEditProfile);
export default __webpack_public_path__ + "static/media/icWarningEditProfile.e76bcb097c8b6fb7d2783e0f0be2001f.svg";
export { ForwardRef as ReactComponent };